// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3SGnZ","colMaxWidth":"Table_colMaxWidth__2nkoL"};